export default function getHostname() {
    if (typeof window !== 'undefined') {
        return window.gridHostname || window.location.hostname;
    }
    return '';
}
